import { useMemo } from "react";
import { useI18nContext } from "@hopper-b2b/i18n";
import type { AboutHotelSectionComponentProps } from "./AboutHotelSection";

export const useAboutHotelSection = ({
  hotel,
}: AboutHotelSectionComponentProps) => {
  const { t } = useI18nContext();

  return useMemo(() => {
    return {
      context: { hotel },
      text: {
        title: t("core-hotels.shop.hotelDescription.title"),
        content: hotel.description,
        readMore: t("core-hotels.shop.hotelDescription.readMore"),
      },
    };
  }, [hotel, t]);
};
